<template>
  <div class="manager_dashboard_mentee_lists">
    <div class="row mt-5">
      <div class="col-11 d-flex pr-0 custom-pl-0">
        <div class="h4 text-uppercase float-left mr-2">Mentees</div>
        <div class="float-left flex-grow-1">
          <div class="input-group search_mentees_txtbox">
            <input type="text" class="form-control" placeholder="Search Mentees" aria-label="Search Mentees" v-model="searchQuery" @input="filterSortMentees" />

            <div class="input-group-append">
              <span class="input-group-text"><i class="fa fa-search" aria-hidden="true"></i></span>
            </div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
      <div class="col-1 px-0">
        <div class="text-right float-right search_mentees_icons" style="font-size:16px;">
          <a href="#" class="float-left mt-1 mr-0" v-if="sortOrder == 'desc'" @click.prevent="toggleSortOrder" title="Sort by Ascending">
            <img class="" src="@/assets/manager/mentee_list_sort_ascending.png" />
          </a>
          <a href="#" class="float-left mt-1 mr-0" v-if="sortOrder == 'asc'" @click.prevent="toggleSortOrder" title="Sort by Descending">
            <img class="" src="@/assets/manager/mentee_list_sort_descending.png" />
          </a>
          <div class="clearfix"></div>
        </div>
      </div>
    </div>    

    <div class="row mt-3 ml-1 mb-5 shadow mentee-panel-wrapper" v-for="option in 3" v-if="menteeLoading == true">

      <div class="col">
        <div class="row mb-2 mt-3">
          <div class="col-5 pl-4">
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
          <div class="col-4 pr-4 text-right" >
          </div>
          <div class="col-3 pr-4 text-right" >
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-12 pl-5 pr-5">
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
        </div>
        <div class="row">
          <div class="col-12 pl-5 pr-5 pt-1">
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-12 pl-5 pr-5 pt-1">
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
        </div>
        <div class="row mb-4 mt-3">
          <div class="col-5 pl-4">
            <PuSkeleton :count="1"></PuSkeleton>
          </div>
        </div>
      </div>

    </div>

    <DashboardMentees v-for="(mentee, index) in filteredMentees" :key="mentee.id" :mentee="mentee" :index="index" :menteeId="mentee.id" @reduceRepCount="reduceRepCount" @openRepToReviewModal="openRepToReviewModal" @closeAddRep="closeAddRep"></DashboardMentees>

  </div>
</template>

<script>
import axios from 'axios';
import DashboardMentees from '@/components/manager/dashboard_mentees.vue';

export default {
  data: function () {
    return {
      accountItems: [],
      menteeItems: [],
      searchQuery: '',
      filteredMentees: [],
      sortOrder: 'asc',
      menteeLoading: false,
    }
  },
  components: {
    DashboardMentees,
  },
  methods: {
    reduceRepCount(data) {
      const menteeIndex = this.menteeItems.findIndex((mentee) => mentee.id == data.menteeId);
      if (menteeIndex !== -1) {
        this.menteeItems[menteeIndex].menteeRepCount = data.repCount;
      }
    },
    closeAddRep() {
      this.$parent.getAccountStatistics();
    },
    filterSortMentees() {

      const query = this.searchQuery.toLowerCase();
      let filteredMentees = this.menteeItems.filter(mentee => mentee.first_name.toLowerCase().includes(query));

      filteredMentees.sort((a, b) => {
        const comparison = a.first_name.localeCompare(b.first_name);
        return this.sortOrder === 'asc' ? comparison : -comparison;
      });

      this.filteredMentees = filteredMentees;
    },
    toggleSortOrder() {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      this.filterSortMentees();
    },
    openRepToReviewModal(menteeId) {
      this.$emit('openRepToReviewModal', menteeId);
    },
  },
  created() {
    this.menteeLoading = true;
    axios('/desktop/v2/mentor/get-mentees', {
      method: 'GET',
      params: {
        account_id: this.$store.state.user_accountid, 
      }
    })
    .then(resp => {
      this.accountItems = resp.data;
      this.menteeLoading = false;
      this.menteeItems = this.accountItems.mentee;
      this.filterSortMentees();
    })
    .catch(() => {});
  },
  mounted() {

  },
}
</script>

<style scoped>
.search_mentees_txtbox input {
  height: 32px;
  border-right: 0;
  font-size: 12px;
  border-radius: 10px;
  border-color: #b8b8b8;
}
.search_mentees_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-color: #b8b8b8;
  border-left: 0;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
.sort_by_selectbox {
  height: 28px;
  border: 0px;
  width: auto;
  font-size: 11px;
  text-decoration: underline;
  padding-left: 0;
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #b8b8b8;
}
.search_mentees_icons i {
  color: #d4d7d7;
}
.search_mentees_icons img {
  opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/mentor/dashboard_mentees_list.vue